// extracted by mini-css-extract-plugin
export default {"star":"styles_star__KHN4l"};